import { OnboardingShell } from "./OnboardingShell";

export function OnboardingClinicPage() {
  return (
    <OnboardingShell
      step={1}
      title="Thông tin phòng khám"
      description="Tên phòng khám, địa chỉ, giờ làm việc, mã số thuế, số giấy phép hoạt động."
      ctaTo="/settings/clinic"
      ctaLabel="Mở cài đặt phòng khám"
      backTo="/onboarding/welcome"
      nextTo="/onboarding/services"
    >
      <p className="text-muted-foreground">
        Điền thông tin cơ bản của phòng khám. Thông tin này hiển thị trên đơn
        thuốc, hoá đơn và biên lai.
      </p>
    </OnboardingShell>
  );
}
